module.exports = __webpack_public_path__ + "static/media/doc-file.a5d412a4.svg";